/* class decorator */
export function StaticImplements<T>() {
  return <U extends T>(constructor: U) => {
    return constructor;
  };
}
